import { jsx as m, jsxs as R, Fragment as fe } from "react/jsx-runtime";
import G, { useState as T, useRef as A, useEffect as P, useCallback as C, forwardRef as he, useImperativeHandle as pe, memo as te, useMemo as ce } from "react";
import Ae from "use-deep-compare-effect";
import Ne from "style-object-to-css-string";
import Te from "styled-components";
import { AgGridReact as De } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import { useCustomCompareMemo as Me } from "use-custom-compare";
import me from "lodash/debounce";
const Re = ({
  dataSource: e,
  onFetchChildrenForRecord: t,
  childField: n = "child_id"
}) => {
  const [s, a] = T([]), [l, c] = T([]), r = A(/* @__PURE__ */ new Map()), [o, i] = T(
    e.map(
      (h) => Z({
        entry: h,
        childField: n,
        idLevelMap: r.current
      })
    )
  );
  P(() => {
    i(
      e.map(
        (h) => Z({
          entry: h,
          childField: n,
          idLevelMap: r.current
        })
      )
    );
  }, [e]);
  const d = C(
    (h) => {
      s.indexOf(h) === -1 ? (s.push(h), a([...s])) : a(s.filter((u) => u !== h));
    },
    [s]
  ), f = C(
    (h) => s.includes(h),
    [s]
  ), b = C(
    (h) => l.includes(h),
    [l]
  ), y = (h) => r.current.get(h) || 0, v = C(
    (h) => {
      const u = o.find((g) => g.id === h);
      return u ? u[n] !== void 0 && u[n].length > 0 : !1;
    },
    [n, o]
  ), I = C(
    (h) => {
      const u = o.find((g) => g.id === h);
      return u ? u.isLoading : !1;
    },
    [o]
  ), x = C(
    (h) => {
      const u = o.find((E) => E.id === h);
      if (!u)
        return [];
      const g = u[n];
      return g ? o.filter((E) => g.includes(E.id)) : [];
    },
    [n, o]
  ), p = C(
    async (h) => {
      const u = o.find((g) => g.id === h.id);
      if (!u)
        return !1;
      if (!u.isLoading) {
        if (!f(h.id) && !b(u.id)) {
          i(
            ee(
              {
                ...u,
                isLoading: !0
              },
              o
            )
          );
          try {
            const g = await (t == null ? void 0 : t(u)) || [];
            g.forEach((E) => {
              r.current.set(E.id, u.level + 1);
            }), i(
              ee(
                {
                  ...u,
                  isLoading: !1
                },
                [
                  ...o,
                  ...g.map((E) => Z({
                    entry: E,
                    childField: n,
                    idLevelMap: r.current
                  }))
                ]
              )
            ), l.push(u.id), c([...l]);
          } catch (g) {
            console.error(g), i(
              ee(
                {
                  ...u,
                  isLoading: !1
                },
                o
              )
            );
          }
        }
        d(h.id);
      }
    },
    [
      o,
      f,
      b,
      d,
      t,
      l,
      n
    ]
  ), k = C(
    (h) => I(h.id) ? "loading" : v(h.id) ? f(h.id) ? "collapse" : "expand" : "none",
    [I, v, f]
  ), w = C(() => {
    const u = o.filter((g) => g.level === 0).map((g) => g.id);
    return s.forEach((g) => {
      const E = o.find((L) => L.id === g);
      E && E.child_id && E.child_id.forEach((L) => {
        u.includes(L) || u.push(L);
      });
    }), u;
  }, [s, o]);
  return {
    keyIsOpened: f,
    onExpandableIconClicked: p,
    getExpandableStatusForRow: k,
    getChildsForParent: x,
    getAllVisibleKeys: w,
    getLevelForKey: y
  };
};
function Z({
  entry: e,
  childField: t,
  idLevelMap: n
}) {
  return {
    id: e.id,
    [t]: e[t],
    isLoading: !1,
    level: n.get(e.id) || 0,
    data: e
  };
}
const ee = (e, t) => t.map((n) => n.id === e.id ? e : n), Pe = ({
  selectionRowKeysProps: e = []
}) => {
  const [t, n] = T(
    e
  );
  Ae(() => {
    n(e);
  }, [e]);
  const s = C(
    (r) => {
      if (t.length === r.length || t.length > 0) {
        n([]);
        return;
      }
      n(r);
    },
    [t, n]
  ), a = C(
    (r, o) => {
      o.length !== 0 && n(r ? [.../* @__PURE__ */ new Set([...t, ...o])] : t.filter((i) => !o.includes(i)));
    },
    [t, n]
  ), l = C(
    (r) => {
      if (t.find(
        (i) => r.id === i
      ) === void 0) {
        n([...t, r.id]);
        return;
      }
      n([...t.filter((i) => i !== r.id)]);
    },
    [t, n]
  ), c = C(
    (r) => t.find(
      (i) => r.id === i
    ) !== void 0,
    [t]
  );
  return {
    selectedRowKeys: t,
    isRowSelected: c,
    toggleAllRowsSelected: s,
    toggleRowSelected: l,
    changeSelected: a
  };
}, $e = (e, t) => {
  const [n, s] = T(null), [a, l] = T(!1), [c, r] = T(null);
  return C(
    (i, d) => {
      if (d.nativeEvent.shiftKey) {
        const f = e.findIndex((x) => x === i), b = e.findIndex((x) => x === n), y = e.findIndex(
          (x) => x === c
        ), v = Math.min(f, b), I = Math.max(f, b);
        if (v > -1 && I > -1) {
          t(a, e.slice(v, I + 1)), y > I && t(
            !a,
            e.slice(I + 1, y + 1)
          ), y < v && t(
            !a,
            e.slice(y, v)
          ), r(i);
          return;
        }
      } else
        s(i), r(null), l(d.target.checked);
      t(d.target.checked, [i]);
    },
    [
      t,
      e,
      n,
      s,
      a,
      l,
      c,
      r
    ]
  );
}, ze = (e) => {
  const [t, n] = T(e), s = C(
    (l) => {
      if (t && l === t.id)
        return t;
    },
    [t]
  ), a = C(
    (l) => {
      if (!t) {
        n({
          id: l,
          desc: !1
        });
        return;
      }
      if (t.id !== l) {
        n({
          id: l,
          desc: !1
        });
        return;
      }
      if (t.desc === !1) {
        n({
          id: l,
          desc: !0
        });
        return;
      }
      t.desc === !0 && n(void 0);
    },
    [t]
  );
  return {
    localSorter: t,
    getColumnSorter: s,
    handleColumnClick: a
  };
}, He = Te.div`
  overflow-x: auto;
  height: ${({ height: e }) => `${e}px` || "auto"};
  border-bottom: 1px solid #f0f0f0;
  ${(e) => Ne(e.containerStyle ?? {})}

  table {
    white-space: nowrap;
    border-spacing: 0;
    width: 100%;

    tr {
      cursor: ${({ canClick: e }) => e ? "pointer" : "auto"};
      user-select: none;

      &:nth-child(odd) {
        background: #fff;
      }

      &:nth-child(even) {
        background: #fafafa;
      }

      &:hover {
        background-color: #f2f2f2;
      }

      td {
        border-bottom: 1px solid #f0f0f0;
      }

      :last-child td {
        border-bottom: 0;
      }
    }

    th {
      position: sticky;
      top: 0;
      background-color: #fafafa;
      border-bottom: 1px solid #f0f0f0;
      z-index: 5;
    }

    th:hover {
      background-color: #f2f2f2;
    }

    th .arrow {
      padding-left: 10px;
      font-size: 0.65em;
      color: #bdbdbd;
    }

    th .ctx {
      display: flex;
    }

    th,
    td {
      margin: 0;
      padding: 0.5rem;

      :last-child {
        border-right: 0;
      }
    }

    /* Responsive */
    @media (max-width: 991px) {
      thead {
        display: none;
      }

      td:nth-of-type(1) {
        width: ${(e) => e.readonly ? "auto !important" : "50px"};
        display: ${(e) => e.readonly ? "block" : ""};
      }

      td:nth-of-type(n + 2) {
        display: block;
        width: auto !important;
      }

      .rft-label {
        display: block !important;
      }
    }
  }
`, ye = ({
  value: e,
  onChange: t
}) => {
  const n = G.useRef();
  return G.useEffect(() => {
    const s = n.current;
    e === !0 ? (s.checked = !0, s.indeterminate = !1) : e === !1 ? (s.checked = !1, s.indeterminate = !1) : e === null && (s.checked = !1, s.indeterminate = !0);
  }), /* @__PURE__ */ m(
    "input",
    {
      onDoubleClick: (s) => {
        s.stopPropagation();
      },
      ref: n,
      type: "checkbox",
      onChange: t,
      tabIndex: -1
    }
  );
}, Fe = ({
  onRowSelectionChange: e,
  allRowsAreSelected: t,
  columns: n,
  toggleAllRowsSelected: s,
  selectedRowKeys: a,
  handleColumnClick: l,
  getColumnSorter: c,
  sortEnabled: r,
  readonly: o,
  status: i = !1,
  headerStyle: d
}) => /* @__PURE__ */ R(fe, { children: [
  e && !o && /* @__PURE__ */ m(
    "th",
    {
      style: {
        width: 10,
        left: 0,
        position: "sticky",
        backgroundColor: "#f2f2f2",
        ...d,
        cursor: "auto"
      },
      children: /* @__PURE__ */ m(
        "div",
        {
          style: {
            width: 50,
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          },
          children: /* @__PURE__ */ m(
            ye,
            {
              value: t ? !0 : a.length === 0 ? !1 : null,
              onChange: s
            }
          )
        }
      )
    },
    "react_formiga_table_selection"
  ),
  i && /* @__PURE__ */ m("th", { style: { ...d } }, "th-status"),
  n.map((f) => /* @__PURE__ */ m(
    "th",
    {
      style: { ...d },
      onClick: r ? () => {
        l(f.key);
      } : void 0,
      children: /* @__PURE__ */ R("div", { className: "ctx", children: [
        /* @__PURE__ */ m(
          "div",
          {
            style: {
              flex: 1,
              display: "flex",
              justifyContent: "space-between",
              ...d == null ? void 0 : d.rftLabel
            },
            children: f.title
          }
        ),
        /* @__PURE__ */ m("div", { style: { display: "flex", alignItems: "center" }, children: /* @__PURE__ */ m(
          "span",
          {
            className: "arrow",
            style: {
              visibility: c(f.key) !== void 0 ? void 0 : "hidden",
              marginLeft: "auto"
            },
            children: c(f.key) !== void 0 && c(f.key).desc ? " ▼" : " ▲"
          },
          f.key
        ) })
      ] })
    },
    f.key
  ))
] }), ae = ({
  column: e,
  row: t,
  columnIdx: n,
  level: s,
  getColumnSorter: a,
  expandableOpts: l,
  getExpandableStatusForRow: c,
  onExpandableIconClicked: r,
  onCellRender: o,
  rowIsSelected: i,
  cellStyle: d
}) => {
  const f = a(e.key) !== void 0 ? {
    backgroundColor: i ? "#E6F7FF" : "#fafafa"
  } : i ? {
    backgroundColor: i ? "#E6F7FF" : void 0
  } : {};
  let b;
  return o ? b = o({
    column: e,
    columnIdx: n,
    rowKey: t.id,
    value: t[e.key]
  }) : e.render ? b = e.render(t[e.key]) : b = t[e.key], /* @__PURE__ */ R("td", { style: f, children: [
    /* @__PURE__ */ m(
      _e,
      {
        row: t,
        columnIdx: n,
        expandableOpts: l,
        getExpandableStatusForRow: c,
        onExpandableIconClicked: r,
        level: s
      }
    ),
    /* @__PURE__ */ R("div", { style: { display: "inline-block", width: "100%", ...d }, children: [
      /* @__PURE__ */ m(
        "div",
        {
          className: "rft-label",
          style: { display: "none", ...d == null ? void 0 : d.rftLabel },
          children: e.title
        }
      ),
      b
    ] })
  ] });
};
function _e({
  row: e,
  columnIdx: t,
  expandableOpts: n,
  getExpandableStatusForRow: s,
  onExpandableIconClicked: a,
  level: l
}) {
  if (!n)
    return null;
  const c = s(e);
  if (c === "none" || t !== 0)
    return /* @__PURE__ */ m("div", { style: { display: "inline-block", width: 19 + l * 25 } });
  let r;
  return c === "expand" ? r = n.expandIcon : c === "collapse" ? r = n.collapseIcon : c === "loading" && (r = n.loadingIcon), /* @__PURE__ */ m("div", { style: { display: "inline-block" }, children: /* @__PURE__ */ m(
    r,
    {
      style: { marginRight: 5, marginLeft: l * 25 },
      onClick: () => {
        a(e);
      }
    }
  ) });
}
class de extends G.Component {
  constructor(t) {
    super(t), this.state = { hasError: !1, error: null, errorInfo: null };
  }
  static getDerivedStateFromError(t) {
    return { hasError: !0, error: t };
  }
  componentDidCatch(t, n) {
    this.setState({ errorInfo: n }), console.error("Error caught by ErrorBoundary:", t, n);
  }
  render() {
    return this.state.hasError ? /* @__PURE__ */ R(
      "div",
      {
        style: {
          margin: "10px",
          padding: "10px",
          borderRadius: "4px",
          backgroundColor: "#FFF2F0"
        },
        children: [
          /* @__PURE__ */ m("strong", { style: { color: "red" }, children: "Something went wrong." }),
          /* @__PURE__ */ m("details", { style: { whiteSpace: "pre-wrap" }, children: /* @__PURE__ */ R("pre", { children: [
            this.state.error && this.state.error.toString(),
            /* @__PURE__ */ m("br", {}),
            this.state.errorInfo && this.state.errorInfo.componentStack
          ] }) })
        ]
      }
    ) : this.props.children;
  }
}
const Be = ({
  onRowSelectionChange: e,
  dataSource: t,
  columns: n,
  getColumnSorter: s,
  onRowStyle: a,
  onRowStatus: l,
  onRowDoubleClick: c,
  isRowSelected: r,
  toggleRowSelected: o,
  expandableOpts: i,
  onExpandableIconClicked: d,
  getExpandableStatusForRow: f,
  keyIsOpened: b,
  getChildsForParent: y,
  getLevelForKey: v,
  onCellRender: I,
  cellStyle: x,
  readonly: p
}) => /* @__PURE__ */ m(fe, { children: t.filter((k) => v(k.id) === 0).map((k) => ge({
  row: k,
  columns: n,
  onRowStyle: a,
  onRowStatus: l,
  onRowDoubleClick: c,
  onRowSelectionChange: e,
  isRowSelected: r,
  toggleRowSelected: o,
  expandableOpts: i,
  getExpandableStatusForRow: f,
  onExpandableIconClicked: d,
  getColumnSorter: s,
  keyIsOpened: b,
  getChildsForParent: y,
  cellStyle: x,
  readonly: p
})) });
function ge({
  row: e,
  columns: t,
  onRowDoubleClick: n,
  onRowSelectionChange: s,
  isRowSelected: a,
  toggleRowSelected: l,
  expandableOpts: c,
  getExpandableStatusForRow: r,
  onExpandableIconClicked: o,
  getColumnSorter: i,
  keyIsOpened: d,
  getChildsForParent: f,
  onRowStyle: b,
  onRowStatus: y,
  level: v = 0,
  onCellRender: I,
  cellStyle: x,
  readonly: p
}) {
  var u;
  const k = b ? b(e) : "", w = a(e);
  let h = [
    /* @__PURE__ */ R(
      "tr",
      {
        style: k,
        onDoubleClick: () => {
          n == null || n(e);
        },
        children: [
          s && !p && /* @__PURE__ */ m(
            "td",
            {
              style: {
                left: 0,
                position: "sticky",
                backgroundColor: w ? "#E6F7FF" : "#f2f2f2",
                cursor: "auto"
              },
              onDoubleClick: (g) => {
                g.stopPropagation(), g.preventDefault();
              },
              children: /* @__PURE__ */ m(
                "div",
                {
                  style: {
                    width: 50,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                  },
                  children: !p && /* @__PURE__ */ m(
                    ye,
                    {
                      value: w,
                      onChange: (g) => {
                        l(e.id, g);
                      }
                    }
                  )
                }
              )
            },
            `react_formiga_table_selection-${e.id}`
          ),
          y && /* @__PURE__ */ m(de, { children: /* @__PURE__ */ m(
            ae,
            {
              row: e,
              getColumnSorter: () => {
              },
              column: "row-status",
              columnIdx: -1,
              onCellRender: () => y(e),
              expandableOpts: c,
              getExpandableStatusForRow: r,
              onExpandableIconClicked: o,
              level: v,
              rowIsSelected: w,
              cellStyle: x
            }
          ) }, `status-${e.id}`),
          t.map((g, E) => /* @__PURE__ */ m(de, { children: /* @__PURE__ */ m(
            ae,
            {
              column: g,
              columnIdx: E,
              row: e,
              getColumnSorter: i,
              expandableOpts: c,
              getExpandableStatusForRow: r,
              onExpandableIconClicked: o,
              level: v,
              rowIsSelected: w,
              cellStyle: x
            }
          ) }, `${g.key}-${e.id}`))
        ]
      },
      `tr-${e.id}`
    )
  ];
  return c !== void 0 && d(e.id) && (h = h.concat(
    (u = f(e.id)) == null ? void 0 : u.map((g) => ge({
      row: g.data,
      columns: t,
      onRowStyle: b,
      onRowDoubleClick: n,
      onRowSelectionChange: s,
      isRowSelected: a,
      toggleRowSelected: l,
      expandableOpts: c,
      getExpandableStatusForRow: r,
      onExpandableIconClicked: o,
      getColumnSorter: i,
      keyIsOpened: d,
      getChildsForParent: f,
      level: g.level,
      onCellRender: I,
      onRowStatus: y
    }))
  )), h;
}
const je = he((e, t) => {
  const {
    height: n,
    loading: s,
    loadingComponent: a,
    dataSource: l,
    columns: c,
    onRowDoubleClick: r,
    onRowStyle: o,
    onRowStatus: i,
    onRowSelectionChange: d,
    onChangeSort: f,
    sorter: b,
    expandableOpts: y,
    onCellRender: v,
    readonly: I,
    selectionRowKeys: x,
    customStyle: p
  } = e, {
    selectedRowKeys: k,
    toggleAllRowsSelected: w,
    isRowSelected: h,
    changeSelected: u
  } = Pe({
    selectionRowKeysProps: x
  });
  pe(t, () => ({
    unselectAll: () => {
      w([]);
    }
  }));
  const g = $e(
    l.map((j) => j.id),
    u
  ), { localSorter: E, getColumnSorter: L, handleColumnClick: z } = ze(b), {
    keyIsOpened: H,
    onExpandableIconClicked: Q,
    getExpandableStatusForRow: U,
    getChildsForParent: F,
    getAllVisibleKeys: $,
    getLevelForKey: _
  } = Re({
    dataSource: l,
    onFetchChildrenForRecord: y == null ? void 0 : y.onFetchChildrenForRecord,
    childField: y == null ? void 0 : y.childField
  });
  P(() => {
    d == null || d(k);
  }, [k]), P(() => {
    f == null || f(E);
  }, [E]);
  const B = C(() => k.length === 0 ? !1 : y ? $().length === k.length : l.length === k.length, [l.length, y, k.length]), V = C(() => {
    w($());
  }, [w, $]);
  return s ? a : /* @__PURE__ */ m(
    He,
    {
      height: n,
      canClick: r !== void 0,
      readonly: I,
      containerStyle: p == null ? void 0 : p.containerStyle,
      children: /* @__PURE__ */ R("table", { style: p == null ? void 0 : p.tableStyle, children: [
        /* @__PURE__ */ m("thead", { children: /* @__PURE__ */ m("tr", { children: /* @__PURE__ */ m(
          Fe,
          {
            allRowsAreSelected: B(),
            columns: c,
            onRowSelectionChange: d,
            selectedRowKeys: k,
            toggleAllRowsSelected: V,
            handleColumnClick: z,
            getColumnSorter: L,
            sortEnabled: y === void 0,
            readonly: I,
            status: !!i,
            headerStyle: p == null ? void 0 : p.headerStyle
          }
        ) }) }),
        /* @__PURE__ */ m("tbody", { children: /* @__PURE__ */ m(
          Be,
          {
            dataSource: l,
            columns: c,
            onRowSelectionChange: d,
            getColumnSorter: L,
            onRowDoubleClick: r,
            onRowStyle: o,
            onRowStatus: i,
            isRowSelected: h,
            toggleRowSelected: g,
            expandableOpts: y,
            onExpandableIconClicked: Q,
            getExpandableStatusForRow: U,
            keyIsOpened: H,
            getChildsForParent: F,
            getLevelForKey: _,
            onCellRender: v,
            cellStyle: p == null ? void 0 : p.cellStyle,
            readonly: I
          }
        ) })
      ] })
    }
  );
});
je.displayName = "Table";
const Oe = (e, t) => Me(
  () => e,
  [e],
  (n, s) => {
    const a = n[0], l = s[0], c = a.map((o) => o[t]).sort((o, i) => o.localeCompare(i)).join(","), r = l.map((o) => o[t]).sort((o, i) => o.localeCompare(i)).join(",");
    return c === r;
  }
), be = te(
  ({
    value: e,
    onChange: t
  }) => {
    const n = G.useRef();
    return P(() => {
      const s = n.current;
      e === !0 ? (s.checked = !0, s.indeterminate = !1) : e === !1 ? (s.checked = !1, s.indeterminate = !1) : e === null && (s.checked = !1, s.indeterminate = !0);
    }), /* @__PURE__ */ m(
      "input",
      {
        style: {
          width: "13px",
          height: "13px",
          border: "1px solid grey",
          cursor: "pointer",
          margin: 0
        },
        onDoubleClick: (s) => {
          s.stopPropagation();
        },
        ref: n,
        type: "checkbox",
        onChange: t,
        tabIndex: -1
      }
    );
  }
);
be.displayName = "HeaderCheckboxComp";
const Ce = te(
  ({
    selectedRowKeysLength: e,
    totalRows: t,
    allRowSelected: n,
    onHeaderCheckboxChange: s,
    allRowSelectedMode: a
  }) => {
    const l = e === 0, c = e > 0 && t !== e;
    let r = !1;
    return a || t === e && t > 0 || n ? r = !0 : l ? r = !1 : c && (r = null), /* @__PURE__ */ m(be, { value: r, onChange: s });
  }
);
Ce.displayName = "HeaderCheckbox";
const We = 50, qe = ({
  gridRef: e,
  onRowSelectionChange: t,
  onAllRowSelectedModeChange: n,
  totalRows: s,
  allRowSelectedModeProps: a = !1
}) => {
  const [l, c] = T(
    []
  ), [r, o] = T(
    a
  ), i = A(!1), d = A([]), f = A(!1), b = A(null);
  P(() => {
    i.current = r;
  }, [r]), P(() => {
    o(a), a && (c([]), f.current = !0);
  }, [a]), P(() => {
    n == null || n(r);
  }, [r]);
  const y = C(() => {
    var k;
    let p = !1;
    r ? p = !1 : !r && l.length === 0 ? p = !0 : !r && l.length === s ? p = !1 : (r || l.length > 0) && (p = !0), f.current = !0, (k = e == null ? void 0 : e.current) == null || k.api.forEachNode((w) => {
      w.setSelected(p);
    }), o(p), b.current && clearTimeout(b.current), b.current = setTimeout(() => {
      f.current = !1;
    }, 1e3);
  }, [r, l.length, s, e]), v = C(
    (p) => {
      if (f.current) {
        t == null || t([]), c([]);
        return;
      }
      o(!1);
      let w = p.api.getSelectedNodes().map(
        (h) => h.data.id
      );
      w = w.concat(
        d.current
      ), t == null || t(w), c(w);
    },
    [t]
  ), I = C(
    me((p) => {
      v == null || v(p);
    }, We),
    [v]
  ), x = C((p) => {
    d.current = p;
  }, []);
  return {
    internalSelectedRowKeys: l,
    onHeaderCheckboxChange: y,
    allRowSelectedMode: r,
    onSelectionChangedDebounced: I,
    selectedRowKeysPendingToRender: d.current,
    setSelectedRowKeysPendingToRender: x
  };
}, Je = ({
  gridRef: e,
  containerRef: t,
  columnsPersistedStateRef: n,
  hasStatusColumn: s
}) => {
  const a = A(!1), l = ["0"];
  s && l.push("$status");
  const c = C(
    (o) => {
      var f;
      const i = o == null ? void 0 : o.reduce(
        (b, y) => b + y.getActualWidth(),
        0
      ), d = (f = t == null ? void 0 : t.current) == null ? void 0 : f.clientWidth;
      return !d || !i ? 0 : d - i;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  return {
    autoSizeColumnsIfNecessary: C(() => {
      !n.current && !a.current && (a.current = !0, setTimeout(() => {
        var d, f, b, y;
        (d = e == null ? void 0 : e.current) == null || d.api.autoSizeAllColumns();
        const o = (f = e == null ? void 0 : e.current) == null ? void 0 : f.api.getAllGridColumns();
        if (!o)
          return;
        const i = c(o);
        if (i > 0) {
          const v = i / (o.length - l.length), x = ((b = e == null ? void 0 : e.current) == null ? void 0 : b.api.getColumnState()).map((p) => ({
            ...p,
            width: l.includes(p.colId) ? p.width : p.width + v
          }));
          (y = e == null ? void 0 : e.current) == null || y.api.applyColumnState({ state: x });
        }
      }, 50));
    }, [c])
  };
}, Ge = ({
  actualColumnKeys: e,
  persistedColumnState: t
}) => {
  if (!t)
    return;
  const n = t.map(
    (c) => c.colId
  ), s = [...e].sort(), a = [
    ...n.filter((c) => c !== "0")
  ].sort();
  if (JSON.stringify(s) === JSON.stringify(a))
    return t;
}, ue = 50, ke = he(
  (e, t) => {
    const {
      onRequestData: n,
      columns: s,
      onRowDoubleClick: a,
      onRowSelectionChange: l,
      height: c = 600,
      onRowStyle: r,
      onColumnChanged: o,
      onGetColumnsState: i,
      onChangeFirstVisibleRowIndex: d,
      onGetFirstVisibleRowIndex: f,
      onGetSelectedRowKeys: b,
      totalRows: y,
      onAllRowSelectedModeChange: v,
      allRowSelectedMode: I,
      footer: x,
      footerHeight: p = 50,
      onRowStatus: k,
      statusComponent: w,
      hasStatusColumn: h = !1
    } = e, u = A(null), g = A(!0), E = A(!1), L = A(), z = A(null), H = A(!1), Q = x ? c + p : c, U = x ? c - p : c, { autoSizeColumnsIfNecessary: F } = Je({
      gridRef: u,
      containerRef: z,
      columnsPersistedStateRef: L,
      hasStatusColumn: h
    }), $ = C(
      me((S) => {
        if (!H.current) {
          H.current = !0;
          return;
        }
        o == null || o(S);
      }, ue),
      [o]
    ), _ = C(
      (S) => {
        const K = S.api.getColumnState();
        $(K);
      },
      [$]
    );
    pe(t, () => ({
      unselectAll: () => {
        var S, K;
        W([]), (K = (S = u.current) == null ? void 0 : S.api) == null || K.deselectAll();
      },
      refresh: () => {
        var S, K;
        (K = (S = u.current) == null ? void 0 : S.api) == null || K.purgeInfiniteCache();
      }
    }));
    const {
      onHeaderCheckboxChange: B,
      onSelectionChangedDebounced: V,
      selectedRowKeysPendingToRender: j,
      allRowSelectedMode: O,
      internalSelectedRowKeys: X,
      setSelectedRowKeysPendingToRender: W
    } = qe({
      gridRef: u,
      onRowSelectionChange: l,
      onAllRowSelectedModeChange: v,
      totalRows: y,
      allRowSelectedModeProps: I
    });
    P(() => {
      E.current = O;
    }, [O]);
    const q = Oe(s, "key"), ve = ce(() => ({}), []), xe = ce(() => {
      const S = {
        checkboxSelection: !0,
        suppressMovable: !0,
        sortable: !1,
        lockPosition: !0,
        pinned: "left",
        maxWidth: 50,
        resizable: !1,
        headerComponent: () => /* @__PURE__ */ m(
          Ce,
          {
            totalRows: y,
            selectedRowKeysLength: X.length,
            allRowSelected: y === X.length && y > 0,
            allRowSelectedMode: O,
            onHeaderCheckboxChange: B
          }
        )
      }, K = q.map((N) => ({
        field: N.key,
        sortable: !1,
        headerName: N.title,
        cellRenderer: N.render ? (J) => N.render(J.value) : void 0
      }));
      return [
        S,
        ...h ? [{
          field: "$status",
          suppressMovable: !0,
          sortable: !1,
          lockPosition: !0,
          maxWidth: 30,
          type: "leftAligned",
          pinned: "left",
          resizable: !1,
          headerComponent: () => null,
          cellRenderer: (N) => w == null ? void 0 : w(N.value)
        }] : [],
        ...K
      ];
    }, [
      O,
      q,
      h,
      X.length,
      B,
      w,
      y
    ]), ne = C(
      async (S) => {
        var re, se, oe, le;
        (re = u.current) == null || re.api.showLoadingOverlay();
        const { startRow: K, endRow: Y } = S, N = await n(K, Y);
        let J = -1;
        N.length < Y - K && (J = K + N.length);
        const Ke = h ? await Promise.all(
          N.map(async (D) => {
            const M = await (k == null ? void 0 : k(D));
            return {
              ...D,
              $status: M
            };
          })
        ) : N;
        if (S.successCallback(Ke, J), E.current)
          (se = u == null ? void 0 : u.current) == null || se.api.forEachNode((D) => {
            D.setSelected(!0);
          });
        else {
          const D = b == null ? void 0 : b();
          W(D || []), D && D.length > 0 && ((oe = u == null ? void 0 : u.current) == null || oe.api.forEachNode((M) => {
            var ie;
            (ie = M == null ? void 0 : M.data) != null && ie.id && D.includes(M.data.id) && (M.setSelected(!0), W(
              j.filter(
                (Le) => M.data.id && Le !== M.data.id
              )
            ));
          }));
        }
        (le = u.current) == null || le.api.hideOverlay(), F();
      },
      [
        F,
        h,
        b,
        n,
        k,
        j,
        W
      ]
    ), Se = C(
      (S) => {
        L.current = Ge({
          actualColumnKeys: q.map((K) => K.key),
          persistedColumnState: i == null ? void 0 : i()
        }), L.current && S.api.applyColumnState({
          state: L.current,
          applyOrder: !0
        }), S.api.setGridOption("datasource", {
          getRows: ne
        });
      },
      [q, ne, i]
    ), we = C(
      ({ data: S }) => {
        a == null || a(S);
      },
      [a]
    ), Ie = C(
      (S) => {
        const K = f == null ? void 0 : f();
        K && S.api.ensureIndexVisible(K, "top");
      },
      [f]
    ), Ee = C(
      (S) => {
        g.current || d == null || d(
          S.api.getFirstDisplayedRowIndex()
        ), g.current = !1;
      },
      [d]
    );
    return /* @__PURE__ */ R(
      "div",
      {
        style: {
          display: "flex",
          flexDirection: "column",
          height: Q
        },
        children: [
          /* @__PURE__ */ m(
            "div",
            {
              ref: z,
              className: "ag-grid-default-table ag-theme-quartz",
              style: { height: U, width: "100%" },
              children: /* @__PURE__ */ m(
                De,
                {
                  ref: u,
                  columnDefs: xe,
                  defaultColDef: ve,
                  onRowDoubleClicked: we,
                  rowStyle: {
                    cursor: a ? "pointer" : "auto"
                  },
                  getRowStyle: r,
                  suppressCellFocus: !0,
                  suppressRowClickSelection: !0,
                  rowBuffer: 0,
                  rowSelection: "multiple",
                  onColumnMoved: _,
                  onColumnResized: _,
                  rowModelType: "infinite",
                  cacheBlockSize: 20,
                  onSelectionChanged: V,
                  cacheOverflowSize: 2,
                  maxConcurrentDatasourceRequests: 1,
                  infiniteInitialRowCount: 50,
                  maxBlocksInCache: 10,
                  onGridReady: Se,
                  onFirstDataRendered: Ie,
                  onBodyScroll: Ee,
                  blockLoadDebounceMillis: ue
                }
              )
            }
          ),
          x && /* @__PURE__ */ m("div", { style: { height: p }, children: x })
        ]
      }
    );
  }
);
ke.displayName = "InfiniteTable";
const rt = te(ke);
export {
  rt as InfiniteTable,
  je as Table
};
//# sourceMappingURL=react-formiga-table.es.js.map
